import React from 'react';

// containers
import Page from '../../layout/containers/Page/Page';
import DocumentsContainer from '../../containers/DocumentsContainer/DocumentsContainer';

// Constants
import page from './page';

const DocumentsPage = () => {
  return (
    <Page page={page}>
      <DocumentsContainer />
    </Page>
  );
};

export default DocumentsPage;
